export default __webpack_public_path__ + "static/finewaxdust-086eed11a00a772892ac6751f14b448c.png";